
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'InputClear',
    props: {
        active: {
            type: Boolean,
            default: true,
        },
    },
    emits: {
        clear: () => true,
    },
    setup(props, { emit }) {
        const clear = (): void => {
            emit('clear');
        };
        return {
            clear,
        };
    },
});
